import { Box } from '@mui/material';
import { LoadingIndicator, EmbeddedView } from '@xolv-mybrightlink/common';
import { useDimensionHTMLContent } from '../hooks/useDimensionHTMLContent';
export interface DimensionContentProps {
  postId: string;
}

export const DimensionHTMLContent = (props: DimensionContentProps) => {
  const { postId } = props;
  const { isLoading, html } = useDimensionHTMLContent(postId);
  return (
    <>
      <Box
        sx={{
          px: 8,
          backgroundColor: 'white',
        }}
      >
        <EmbeddedView html={html} />
      </Box>
      {isLoading && <LoadingIndicator fullHeight={true} />}
    </>
  );
};
